import React from "react";

interface ConfirmationModalProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  message,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="dark:bg-boxdark rounded-lg bg-white p-6 shadow-xl">
        <h3 className="mb-4 text-xl font-semibold text-black dark:text-white">
          Потвърждение
        </h3>
        <p className="mb-6 text-gray-700 dark:text-gray-300">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="border-stroke dark:border-strokedark rounded-md border bg-gray-200 px-4 py-2 text-black hover:bg-gray-300 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
          >
            Отказ
          </button>
          <button
            onClick={onConfirm}
            className="bg-primary rounded-md px-4 py-2 text-white hover:bg-opacity-90"
          >
            ОК
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
